import { render, staticRenderFns } from "./TrainingSubscribed.vue?vue&type=template&id=a5c0f52e"
import script from "./TrainingSubscribed.vue?vue&type=script&lang=js"
export * from "./TrainingSubscribed.vue?vue&type=script&lang=js"
import style0 from "./TrainingSubscribed.vue?vue&type=style&index=0&id=a5c0f52e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports